import React from 'react'
import { Card, Row, Col } from 'react-bootstrap';
import Detail from './detail'
import Address from './address'

const ContactInfo = ({onChange, className="", ...props}) => {
  return (
    <Card className={className}>
      <Card.Header className="bg-white font-weight-bold text-scb">
          Merchant Contact Information
      </Card.Header>
      <Card.Body className="px-4 pb-5" >
        <Row style={{ padding: "1rem 0" }}>
          <Col className="border-right">
            <Detail disabled={props.action === 'view'} onChange={(name, value, format)=>onChange("contactDetail", name, value, format)} {...props.contactDetail}/>
          </Col>
          <Col>
            <Address disabled {...props.address}/>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default ContactInfo
